export default [
  {
    path: '/purch-invoice-list',
    name: 'purchInvoice-list',
    component: () => import('@/pages/Purchase/purchInv/List.vue'),
    meta: {
      pageTitle: 'purchase',
      breadcrumb: [{ text: 'purchase', active: true }],
      permission: 'viewPurchTransactions',
    },
  },
  {
    path: '/purch-invoice',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'purchInvoice',
        component: () => import('@/pages/Purchase/purchInv/Edit.vue'),
        meta: {
          pageTitle: 'purchNew',
          breadcrumb: [{ text: 'purchase', active: true }],
          permission: 'addPurchTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'purchInvoice-edit',
        props: true,
        component: () => import('@/pages/Purchase/purchInv/Edit.vue'),
        meta: {
          pageTitle: 'purchEdit',
          breadcrumb: [{ text: 'purchase', active: true }],
          permission: 'editPurchTransactions',
        },
      },
    ],
  },
  {
    path: '/purchase-dashboard',
    name: 'purchase-dashboard',
    component: () => import('@/pages/Purchase/PurchaseDashboard/Edit.vue'),
    meta: {
      pageTitle: 'purchaseDashboard',
      breadcrumb: [{ text: 'purchase', active: true }],
      permission: 'viewPurchDashboard',
    },
  },
  {
    path: '/purchOrder',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'purchOrder',
        component: () => import('@/pages/Purchase/purchadeOrder/Edit.vue'),
        meta: {
          pageTitle: 'purchOrder-new',
          breadcrumb: [{ text: 'purchase', active: true }],
          permission: 'addPurchOrders',
        },
      },
      {
        path: 'edit/:id',
        name: 'purchOrder-edit',
        props: true,
        component: () => import('@/pages/Purchase/purchadeOrder/Edit.vue'),
        meta: {
          pageTitle: 'purchOrder-edit',
          breadcrumb: [{ text: 'purchase', active: true }],
          permission: 'editPurchOrders',
        },
      },
    ],
  },
  {
    path: '/return-purch',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'return-purch-new',
        component: () => import('@/pages/Purchase/ReturnPurch/Edit.vue'),
        meta: {
          pageTitle: 'newReturnPurch',
          breadcrumb: [{ text: 'returnPurch', active: true }],
          permission: 'addReturnPurchTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'return-purch-edit',
        props: true,
        component: () => import('@/pages/Purchase/ReturnPurch/Edit.vue'),
        meta: {
          pageTitle: 'editReturnPurch',
          breadcrumb: [{ text: 'returnPurch', active: true }],
          permission: 'editReturnPurchTransactions',
        },
      },
    ],
  },
];
